import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form, Spinner, Alert } from "react-bootstrap";
import { useQuizLimitStudent } from "../../../../hooks/quiz/useQuizLimitStudent";

const AssignQuizLimitModal = ({
  showModal,
  handleClose,
  selectedStudents,
  classroomId,
  onSuccessCallback,
}) => {
  const [limitValue, setLimitValue] = useState("");
  const { loading, error, success, setQuizLimitStudent, setError } =
    useQuizLimitStudent();

  // Reset state when closing unless it's a success state that hasn't been acknowledged
  const handleModalClose = () => {
    setLimitValue("");
    setError("");
    handleClose();
  };

  const handleSubmit = async () => {
    if (!limitValue || isNaN(limitValue) || Number(limitValue) < 1) {
      setError("Please enter a valid positive limit.");
      return;
    }

    const payload = {
      classroom_id: classroomId,
      students: selectedStudents.map((student) => ({
        id: student.student_id,
        limit: Number(limitValue),
      })),
    };

    const isSuccess = await setQuizLimitStudent(payload);
    if (isSuccess !== null) {
      // If success is true, we call the callback and close
      if (onSuccessCallback) {
        onSuccessCallback();
      }
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={loading ? undefined : handleModalClose}
      centered
      className="custom-modal"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="p-4">
        {success ? (
          <>
            <div className="text-center mb-2">
              <h5 className="text-success fw-bold fs-3">Success</h5>
            </div>
            <p className="text-center mb-4 mt-2 pt-2 custom-modal-description">
              Successfully assigned quiz limit to selected students
            </p>
            <div className="d-flex justify-content-center align-items-center flex-column flex-md-row">
              <Button
                className="custom-primary-button w-auto"
                onClick={handleModalClose}
              >
                Close
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="text-center mb-2">
              <h5 className="text-primary fw-bold fs-3">Assign Quiz Limit</h5>
            </div>
            <p className="text-center mb-4 mt-2 pt-2 custom-modal-description">
              You are about to assign a new quiz limit to{" "}
              <strong>{selectedStudents.length}</strong> selected student
              {selectedStudents.length > 1 ? "s" : ""}.
            </p>

            {error && <Alert variant="danger">{error}</Alert>}

            <Form.Group className="mb-4">
              <Form.Label>New Quiz Attempt Limit</Form.Label>
              <Form.Control
                type="number"
                min="1"
                placeholder="Enter limit (e.g., 5)"
                value={limitValue}
                onChange={(e) => setLimitValue(e.target.value)}
                autoFocus
              />
            </Form.Group>

            <div className="d-flex flex-column flex-md-row gap-3 justify-content-center align-items-center">
              <button
                className="custom-cancel-button"
                onClick={handleModalClose}
                disabled={loading}
              >
                Cancel
              </button>
              <Button
                className="custom-primary-button"
                onClick={handleSubmit}
                disabled={loading || !limitValue}
              >
                {loading ? "Assigning..." : "Confirm"}
              </Button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal >
  );
};

export default AssignQuizLimitModal;
